import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useEffect, useState } from "react";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ClientProvider } from "@/context/ClientContext";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Drive from "@/pages/Drive";
import CalendarPage from "@/pages/CalendarPage";
import Clients from "@/pages/Clients";
import Approvals from "@/pages/Approvals";
import Analytics from "@/pages/Analytics";
import ClientHome from "@/pages/ClientHome";

function Home() {
  const { user } = useAuth();
  return user.role === "client" ? <ClientHome /> : <Dashboard />;
}

function Protected({ children, admin }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-muted-foreground" data-testid="auth-loading">Lädt…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function LoginRoute() {
  const { user } = useAuth();
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

function App() {
  const [toastTheme, setToastTheme] = useState(() => (document.documentElement.classList.contains("light") ? "light" : "dark"));
  useEffect(() => {
    const f = () => setToastTheme(document.documentElement.classList.contains("light") ? "light" : "dark");
    window.addEventListener("theme-changed", f);
    return () => window.removeEventListener("theme-changed", f);
  }, []);
  return (
    <div className="App dark">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginRoute />} />
            <Route
              element={
                <Protected>
                  <ClientProvider>
                    <AppShell />
                  </ClientProvider>
                </Protected>
              }
            >
              <Route path="/" element={<Home />} />
              <Route path="/drive" element={<Drive />} />
              <Route path="/kalender" element={<CalendarPage />} />
              <Route path="/freigaben" element={<Protected admin><Approvals /></Protected>} />
              <Route path="/analytik" element={<Protected admin><Analytics /></Protected>} />
              <Route path="/kunden" element={<Protected admin><Clients /></Protected>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme={toastTheme} position={window.innerWidth < 1024 ? "top-center" : "bottom-right"} />
      </AuthProvider>
    </div>
  );
}

export default App;
